// extracted by mini-css-extract-plugin
module.exports = {"reviewsWrapper":"Reviews_reviewsWrapper__WtgHk"};